import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=unauth, obj=user
  const [settings, setSettings] = useState(null);

  const loadSettings = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (e) {
      /* ignore */
    }
  }, []);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("bk_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      loadSettings();
    } catch (e) {
      localStorage.removeItem("bk_token");
      setUser(false);
    }
  }, [loadSettings]);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("bk_token", data.token);
    setUser(data.user);
    loadSettings();
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("bk_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, settings, setSettings, login, logout, reloadSettings: loadSettings }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
